AoPS.Utils.initKeyChain(AoPS, "Careers");

AoPS.Careers = (function (Careers) {
	Careers.Router = Backbone.Router.extend({
		routes: {
			"job/:jobSlug": "buildAndSearch",
			"*path": "buildJobBoard", // do this so the url actually changes
		},

		urlBase: {
			aops: "/careers",
			acad: "/school/jobs",
		},

		initialize: function (options) {
			this.models = {};
			this.models.master = options.master;
			this.myPage = AoPS.Page.constructPage("careers");
		},

		buildJobBoard: function () {
			this.myPage.clearPage();
			this.setBreadcrumbs();

			this.myPage.showElement({
				constructor: () =>
					new AoPS.Careers.Views.Main({
						model: this.models.master,
						viewName: "JobBoard",
						router: this,
					}),
			});
		},

		buildAndSearch: function (jobSlug) {
			this.myPage.clearPage();
			this.setBreadcrumbs();
			this.myPage.showElement({
				constructor: () =>
					new AoPS.Careers.Views.Main({
						model: this.models.master,
						viewName: "JobPost",
						slug: jobSlug,
						router: this,
					}),
			});
		},

		getUrlBase: function () {
			return this.urlBase[AoPS.repo] || "";
		},

		setBreadcrumbs: function (addlCrumbs) {
			if (addlCrumbs === undefined || !Array.isArray(addlCrumbs)) {
				addlCrumbs = [];
			}

			this.myPage.setBreadcrumbs(this._getBreadcrumbs(addlCrumbs));
		},

		setJobCrumb: function (title, slug) {
			this.setBreadcrumbs([
				{text: title, url: this.urlBase[AoPS.repo] + "/job/" + slug},
			]);
		},

		_getBreadcrumbs: function (addlCrumbs) {
			var base =
				AoPS.repo === "acad"
					? this._getAcadBaseBreadcrumbs()
					: this._getAopsBaseBreadcrumbs();

			var breadcrumbs = base.concat(addlCrumbs);

			// remove url from last breadcrumb
			// for UI consistency
			var last = breadcrumbs.pop();
			last.url = "";
			breadcrumbs.push(last);

			return breadcrumbs;
		},

		_getAopsBaseBreadcrumbs: function () {
			return [
				{
					text: "Careers",
					url: "/careers",
				},
			];
		},

		_getAcadBaseBreadcrumbs: function () {
			return [
				{
					text: "School",
					url: "/school/about",
				},
				{
					text: "Jobs",
					url: "/school/jobs",
				},
			];
		},
	});

	$(window).on("load", function () {
		// Magical refresh
		AoPS.refreshOnBackButtonLoadWithOldData("careers");

		var app = new Careers.Router({
			master: new AoPS.Careers.Models.Master(),
		});
		app.models.master.router = app;

		$("#main-column").prepend(app.myPage.el);
		Backbone.history.start({
			pushState: true,
			root: app.getUrlBase(),
		});
	});

	return Careers;
})(AoPS.Careers || {});
